import React from 'react';
import '../Profile.css';

export interface ProfileSectionProps {
  title: string;
  subtitle?: string;
  rightAction?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  id?: string;
}

export const ProfileSection: React.FC<ProfileSectionProps> = ({
  title,
  subtitle,
  rightAction,
  children,
  className,
  id,
}) => {
  return (
    <div id={id} className={`profile-section ${className || ''}`}>
      <div className="profile-section__header">
        <div className="profile-section__header-text">
          <h2 className="profile-section__title">{title}</h2>
          {subtitle && <p className="profile-section__subtitle">{subtitle}</p>}
        </div>
        {rightAction && (
          <div className="profile-section__action">{rightAction}</div>
        )}
      </div>
      <div className="profile-section__content">
        {children}
      </div>
    </div>
  );
};

export default ProfileSection;
